import { apiClient } from './apiClient';
import { API_CONFIG } from '../config/api';
import { logInfo, logError } from './logtail';

export interface UserSearchResult {
  userId: string;
  email: string;
  effectiveTier?: string; // 'starter' | 'artist' | 'studio'
  storageProvider?: string;

  // DEPRECATED: Use effectiveTier instead
  isPremium: boolean;
}

export const searchUsers = async (query: string): Promise<UserSearchResult[]> => {
  // Validate query parameter
  if (!query || query.trim() === '') {
    logError('Empty query provided to searchUsers', { query });
    return [];
  }

  try {
    const response = await apiClient.get(API_CONFIG.ENDPOINTS.USER_SEARCH, {
      params: { q: query.trim() },
    });
    logInfo('User search completed', { query, results: response.data.length });
    return response.data;
  } catch (error) {
    logError('Failed to search users', { query, error });
    throw error;
  }
};

